import { client } from "../../../../Infrastructure/agent";
export const FieldPerformanceService = {
  getuniqueFieldsData: (producing) =>
    client.post("/fieldperformance/GetUniqueFieldsData", { producing }),

  getFieldPlotData: (fieldId) =>
    client.post("/fieldperformance/GetFieldPlotData", { fieldId }),
};

